<template>
<div class="page-box">
  <div class="page-content">
    <div class="content-header">
      <vs-button
        v-if="isAuth('wx:lineChannel:save')"
        class="add-btn btn box-item"
        style="margin-right: 10px"
        @click="addHandle"
      >新增</vs-button>
      <vs-button
        v-if="isAuth('wx:lineChannel:delete')"
        :disabled="selected.length < 1"
        class="mutil-btn "
        @click="deleteHandle()"
      >批量删除</vs-button>
    </div>
    <div class="vs-table-outer">
      <vs-table
        multiple
        v-model="selected"
        :data="listData"
      >
        <template
          slot="thead">
          <vs-th>
            ID
          </vs-th>
          <vs-th>
            Line频道id
          </vs-th>
          <vs-th>
            Line频道名称
          </vs-th>
          <vs-th>
            备注
          </vs-th>
          <!-- <vs-th>
            密钥
          </vs-th>
          <vs-th>
            接口调用凭证
          </vs-th> -->

          <vs-th>
            状态
          </vs-th>
          <vs-th>
            创建时间
          </vs-th>
          <vs-th>
            更新时间
          </vs-th>
         
          <vs-th>
            操作
          </vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr
            v-for="(tr, index) in data"
            :key="index"
            :data="tr"
          >
            <vs-td>
              {{tr.id}}
            </vs-td>
            <vs-td>
              {{tr.channelId}}
            </vs-td>
            <vs-td>
              {{tr.channelName || '-'}}
            </vs-td>
            <!-- <vs-td
            >
              <span class="rap-normal">{{tr.channelSecret || '-'}}</span>
            </vs-td>
            <vs-td>
              {{tr.accessToken || '-'}}
            </vs-td> -->
            <vs-td
              style="max-width: 300px"
            >
              {{tr.remark}}
            </vs-td>
            <vs-td>
              <span
                class="self-tag"
                :style="getstyle(tr)"
              >{{tr.status==0 ? '禁用': '启用' }}</span>
            </vs-td>
            <vs-td>
              {{parseTime(tr.createTime)}}
            </vs-td>
            <vs-td>
              {{parseTime(tr.updateTime)}}
            </vs-td>
           
            <vs-td>
              <el-button
                v-if="isAuth('wx:lineChannel:update')"
                type="text"
                class=""
                @click.stop="editHandle(tr)"
              >修改</el-button>
              <el-button
                v-if="isAuth('wx:lineChannel:delete')"
                type="text"
                class="delete-btn"
                @click.stop="deleteHandle(tr.id)"
              >删除</el-button>
            </vs-td>
            
          </vs-tr>
        </template>
      </vs-table>
    </div>
    <div class="pagination-outer" v-if="total">
      <div class="paginnation-left">
        <size-change @sizeChange="sizeChange"></size-change>
        <span class="tatol-count">合计 {{total}} 条</span>
      </div>
      <vs-pagination
        class="pagination-box"
        :max="max"
        :total="pageSize"
        v-model="page"
      ></vs-pagination>
    </div>
  </div>
  <add
      :dialog-show="addDialogShow"
      @close="addDialogShow = false"
      @add-success="addSuccess"
  ></add>
  <edit
      :form-data="currentRow"
      :dialog-show="editDialogShow"
      @close="editDialogShow = false"
      @edit-success="editSuccess"
  ></edit>
  <multiple-delete-dialog
    ref="muldelete"
    :ids="ids"
    @sure-delete="confirmDelete"
  ></multiple-delete-dialog>
</div>
</template>

<script>
import { colorRgba } from "@/utils";
import { deleteLineChanelConfig } from '@/api/sys/robitConfig/line'
import initData from '@/mixins/initData'
import add from '@/components/sys/robitCofig/line/add'
import edit from '@/components/sys/robitCofig/line/edit';
import multipleDeleteDialog from "@/components/public/multipleDeleteDialog";
import {deleteMt4ChanelConfig} from "../../../api/sys/robitConfig/mt4";
import { parseTime } from '@/utils/index'
export default {
  name: 'lineList',
  components: {
    add,
    edit,
    multipleDeleteDialog,
  },
  mixins: [initData],
  data() {
    return {
      selected: [],
      addDialogShow: false,
      editDialogShow: false,
      currentRow: {},
      red: '#D85E5F',
      green: '#41B883',
      ids:[],
    }
  },
  created() {
    this.$nextTick(() => {
        this.init();
    })
  },
  methods: {
    parseTime,
      searchHandle(){
        this.page = 1;
        this.init();
      },
    beforeInit() {
      this.url = '/wx/manage/lineChannel/list'
      this.params = {
        page: this.page,
        limit: this.size,
        sidx: 'id',
        order: 'desc'
      }
      return true
    },
    getstyle(tr){
      if(tr.status === 0){
        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        };
      }else {
        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }
    },
    getBtnType(row){
      if(row.status){
        return 'success';
      }else {
        return 'danger';
      }
    },
    getStatusText(row){
      if(row.status){
        return '启用';
      }else {
        return '禁用';
      }
    },
    addHandle() {
        setTimeout(() => {
          this.addDialogShow = true;
        },200);
    },
    addSuccess(){
          this.$message({
              message: '添加成功',
              type: 'success'
          });

          setTimeout(() => {
              this.addDialogShow = false;
              this.searchHandle();
          },1000);
      },
    editHandle(row){
      this.currentRow = row;
      setTimeout(() => {
        this.editDialogShow = true;
      },200);
    },
      editSuccess(){
        this.$message({
          message: '编辑成功',
          type: 'success'
        });

          setTimeout(() => {
              this.editDialogShow = false;
            this.searchHandle();
          },1000);
      },
    deleteHandle(id){
      this.ids = id ? [id] : this.selected.map(item => item.id);
      this.$refs.muldelete.dialogShow = true;
    },
    confirmDelete(ids){
      deleteLineChanelConfig(
        ids
      ).then((res) => {
        this.$refs.muldelete.dialogShow = false;
        this.searchHandle();
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  background-color: #ffffff;
  .header {
    margin-bottom: 20px;
  }
}


</style>
